import { TtfFontResource } from './TtfFontResource';
import { SoundFactory } from './SoundFactory';
import { RenderDevice } from './RenderDevice';
import { Platform } from './Platform';
import { AudioResource } from './AudioResource';
import { SoundSceneObject } from './SoundSceneObject';
import { RenderTargetSceneObject } from './RenderTargetSceneObject';
import { TtfTextInputSceneObject } from './TtfTextInputSceneObject';
import { TtfTextSceneObject } from './TtfTextSceneObject';
import { GlowSceneObject } from './GlowSceneObject';
import { RenderSupport } from './RenderSupport';

export class SceneObjectFactory {
  private _soundFactory: SoundFactory;
  private _renderDevice: RenderDevice;
  private _canvas: HTMLCanvasElement;
  private _platform: Platform;
  private _renderSupport: RenderSupport;

  constructor(
    soundFactory: SoundFactory,
    renderDevice: RenderDevice,
    canvas: HTMLCanvasElement,
    platform: Platform,
    renderSupport: RenderSupport
  ) {
    this._soundFactory = soundFactory;
    this._renderDevice = renderDevice;
    this._canvas = canvas;
    this._platform = platform;
    this._renderSupport = renderSupport;
  }

  createSoundSceneObject(resource: AudioResource): SoundSceneObject {
    const sound = this._soundFactory.createSound(resource);
    return new SoundSceneObject(sound);
  }

  createRenderTargetSceneObject(): RenderTargetSceneObject {
    return new RenderTargetSceneObject(this._renderDevice);
  }

  createTtfTextInputSceneObject(resource: TtfFontResource): TtfTextInputSceneObject {
    return new TtfTextInputSceneObject(this._renderDevice, resource, this._platform, this._canvas);
  }

  createTtfTextSceneObject(resource: TtfFontResource): TtfTextSceneObject {
    return new TtfTextSceneObject(this._renderDevice, resource);
  }

  createGlowSceneObject(): GlowSceneObject {
    return new GlowSceneObject(this._renderDevice, this._renderSupport);
  }

  // TODO add later if required
  // createOverlayButton(): OverlayButton {
  //   return new OverlayButton(this._canvas);
  // }
}
